import { getStore } from '../store/store';
import type { SchedulingTimeRange } from '../store/store';

export function getCalendarSchedulingTimeRange(): SchedulingTimeRange | undefined {
    return getStore().timeRange;
}
